import React from 'react';

export default () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 18.6953V15H18.6953V18.6953H15ZM15 13.1953V9.5H18.6953V13.1953H15ZM9.5 7.69531V4H13.1953V7.69531H9.5ZM15 4H18.6953V7.69531H15V4ZM9.5 13.1953V9.5H13.1953V13.1953H9.5ZM4 13.1953V9.5H7.69531V13.1953H4ZM4 18.6953V15H7.69531V18.6953H4ZM9.5 18.6953V15H13.1953V18.6953H9.5ZM4 7.69531V4H7.69531V7.69531H4Z" fill="currentColor" />
  </svg>
);
